import studioPlansBR from './studioPlans.br';
import studioPlansMX from './studioPlans.mx';
import studioPlansCL from './studioPlans.cl';
import studioPlansCO from './studioPlans.co';

const studioPlans = {
  BR: studioPlansBR,
  MX: studioPlansMX,
  CL: studioPlansCL,
  CO: studioPlansCO,
};

export default studioPlans;
